module.exports = __webpack_public_path__ + "static/media/Dra-Florencia-Ravea.572ea1ec.jpg";